import React, {
  useEffect,
  useState,
} from "react";

import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";

import {
  FiUser,
  FiSettings,
  FiUsers,
  FiList,
  FiFileText,
  FiActivity,
  FiLogOut,
  FiChevronRight,
} from "react-icons/fi";

import { Link } from "react-router-dom";

import avatar1 from "../../assets/images/users/avatar-1.jpg";


const ProfileDropdown = () => {

  const [
    isProfileDropdown,
    setIsProfileDropdown,
  ] = useState(false);

  const [
    user,
    setUser,
  ] = useState(null);


  /* =========================================================
     LOAD AUTHENTICATED USER
  ========================================================= */

  useEffect(() => {

    const storedUser =
      localStorage.getItem("user");

    const storedAuthUser =
      localStorage.getItem("authUser") ||
      sessionStorage.getItem("authUser");

    try {

      if (storedUser) {

        const parsedUser =
          JSON.parse(storedUser);

        setUser(parsedUser);

        return;
      }


      if (storedAuthUser) {

        const parsedUser =
          JSON.parse(storedAuthUser);

        setUser(parsedUser);

      }

    } catch (error) {

      console.error(
        "Unable to load profile user:",
        error
      );

    }

  }, []);


  const toggleProfileDropdown = () => {

    setIsProfileDropdown(
      (previous) => !previous
    );

  };


  /* =========================================================
     USER DATA
  ========================================================= */

  const userName =
    user?.name ||
    user?.username ||
    "User";

  const userEmail =
    user?.email ||
    "";

  const userRole =
    user?.role ||
    "Staff";


  const getInitials = (name) => {

    return String(name || "User")
      .split(" ")
      .filter(Boolean)
      .slice(0, 2)
      .map(
        (part) =>
          part
            .charAt(0)
            .toUpperCase()
      )
      .join("");

  };


  /* =========================================================
     LOGOUT
  ========================================================= */

  const handleLogout = () => {

    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("authUser");

    sessionStorage.removeItem(
      "authUser"
    );

    window.location.href =
      "/login";
  };


  /* =========================================================
     SETTINGS MENU
  ========================================================= */

  const settingsItems = [
    {
      label: "Organization",
      path: "/settings/organization",
      icon: FiSettings,
    },
    {
      label: "Users & Roles",
      path: "/settings/users",
      icon: FiUsers,
    },
    {
      label: "Lead Statuses",
      path: "/settings/statuses",
      icon: FiList,
    },
    {
      label: "Public Lead Form",
      path: "/settings/public-leads",
      icon: FiFileText,
    },
    {
      label: "Audit Logs",
      path: "/settings/audit-logs",
      icon: FiActivity,
    },
  ];


  return (
    <Dropdown
      isOpen={isProfileDropdown}
      toggle={toggleProfileDropdown}
      className="ms-sm-3 header-item topbar-user"
    >

      {/* =====================================================
          PROFILE BUTTON
      ===================================================== */}

      <DropdownToggle
        tag="button"
        type="button"
        className="btn"
      >

        <span className="d-flex align-items-center">

          <img
            className="rounded-circle header-profile-user"
            src={
              user?.avatar ||
              avatar1
            }
            alt="Profile"
          />

          <span className="text-start ms-xl-2">

            <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
              {userName}
            </span>

            <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">
              {userRole}
            </span>

          </span>

        </span>

      </DropdownToggle>


      {/* =====================================================
          DROPDOWN
      ===================================================== */}

      <DropdownMenu
        className="dropdown-menu-end"
        style={{
          minWidth: 300,
        }}
      >

        {/* ===================================================
            USER HEADER
        =================================================== */}

        <div className="px-3 py-3">

          <div className="d-flex align-items-center">

            <div
              className="rounded-circle bg-primary-subtle text-primary d-flex align-items-center justify-content-center flex-shrink-0"
              style={{
                width: 48,
                height: 48,
                fontSize: 16,
                fontWeight: 600,
              }}
            >
              {getInitials(
                userName
              )}
            </div>

            <div className="ms-3 overflow-hidden">

              <h6 className="mb-1 text-truncate">
                {userName}
              </h6>

              <p className="mb-1 text-muted small text-truncate">
                {userEmail ||
                  "No email available"}
              </p>

              <span className="badge bg-primary-subtle text-primary">
                {userRole}
              </span>

            </div>

          </div>

        </div>


        <DropdownItem divider />


        {/* ===================================================
            PROFILE
        =================================================== */}

        <DropdownItem
          tag={Link}
          to="/profile"
        >

          <FiUser
            size={16}
            className="text-muted me-2 align-middle"
          />

          <span className="align-middle">
            My Profile
          </span>

        </DropdownItem>


        {/* ===================================================
            SETTINGS HEADER
        =================================================== */}

        <div className="px-3 pt-2 pb-1">

          <div className="text-uppercase text-muted fs-11 fw-semibold">
            Settings
          </div>

        </div>


        {/* ===================================================
            SETTINGS
        =================================================== */}

        {settingsItems.map(
          (item) => {

            const Icon =
              item.icon;

            return (
              <DropdownItem
                key={item.path}
                tag={Link}
                to={item.path}
                className="d-flex align-items-center justify-content-between"
              >

                <span>

                  <Icon
                    size={16}
                    className="text-muted me-2 align-middle"
                  />

                  <span className="align-middle">
                    {item.label}
                  </span>

                </span>

                <FiChevronRight
                  size={14}
                  className="text-muted"
                />

              </DropdownItem>
            );

          }
        )}


        <DropdownItem divider />


        {/* ===================================================
            LOGOUT
        =================================================== */}

        <DropdownItem
          onClick={handleLogout}
          className="text-danger"
        >

          <FiLogOut
            size={16}
            className="me-2 align-middle"
          />

          <span className="align-middle">
            Logout
          </span>

        </DropdownItem>

      </DropdownMenu>

    </Dropdown>
  );
};


export default ProfileDropdown;